import { ReactElement } from "react";
import { ButtonSize } from "./Button";
import { useCallbackWithoutArguments } from "client/Hooks";
import { ButtonBase } from "../ButtonBase/ButtonBase";
import styles from "./MultiLineButton.module.less";
import classNames from "classnames";

export type MultiLineButtonProps = {
	size?: ButtonSize;
	text: string;
	onClick: () => void;
	trackingId: string;
	isDisabled?: boolean;
};

export const MultiLineButton = (props: MultiLineButtonProps): ReactElement => {
	const {
		size = "normal",
		text,
		onClick: onClickFromProps,
		trackingId,
		isDisabled
	} = props;

	const onClick: () => void = useCallbackWithoutArguments(onClickFromProps);

	return (
		<ButtonBase
			trackingId={trackingId}
			className={classNames(
				styles.root,
				{
					[styles.root_large]: size === "large"
				}
			)}
			onClick={onClick}
			disabled={isDisabled}
		>
			{text}
		</ButtonBase>
	);
};
MultiLineButton.displayName = "MultiLineButton";
